<!-- 我的发布 -->
<template>
  <div class="tab-container">
    <!-- 标签栏 -->
    <div class="tab-header">
      <div
        v-for="tab in tabs"
        :key="tab.id"
        class="tab-item"
        :class="{ active: activeTab === tab.id }"
        @click="setActiveTab(tab.id)"
      >
        {{ tab.title }}
        <!-- 下边框 -->
        <div v-if="activeTab === tab.id" class="tab-underline"></div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="tab-content">
      <component :is="currentTabComponent" />
    </div>
  </div>
</template>

<script>
import PatentContent from "../MyPublish/PatentContent.vue";
import TrademarkContent from "../MyPublish/TrademarkContent.vue";
import SciTechContent from "../MyPublish/SciTechContent.vue";
import TechPurchaseContent from "../MyPublish/TechPurchaseContent.vue"; // 新增
import PurchasePatentContent from "../MyPublish/PurchasePatentContent.vue";
import PurchaseTrademarkContent from "../MyPublish/PurchaseTrademarkContent.vue";
export default {
  name: "App",
  data() {
    return {
      activeTab: "patent",
      tabs: [
        { id: "patent", title: "专利", component: "PatentContent" },
        { id: "trademark", title: "商标", component: "TrademarkContent" },
        { id: "sciTech", title: "科技成果", component: "SciTechContent" },
        {
          id: "techPurchase",
          title: "技术求购",
          component: "TechPurchaseContent",
        },
        {
          id: "purchasePatent",
          title: "专利求购",
          component: "PurchasePatentContent",
        },
        {
          id: "purchaseTrademark",
          title: "商标求购",
          component: "PurchaseTrademarkContent",
        },
      ],
    };
  },
  methods: {
    setActiveTab(tabId) {
      this.activeTab = tabId;
    },
  },
  computed: {
    currentTabComponent() {
      const tab = this.tabs.find((t) => t.id === this.activeTab);
      return tab ? tab.component : null;
    },
  },
  components: {
    PatentContent,
    TrademarkContent,
    SciTechContent,
    TechPurchaseContent, // 注册新增的组件
    PurchasePatentContent,
    PurchaseTrademarkContent,
  },
};
</script>

<style scoped lang="less">
.tab-container {
  padding: 20px;
}

.tab-header {
  display: flex;
  // justify-content: center;
  align-items: center;
}

.tab-item {
  position: relative;
  padding-bottom: 3px;
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #434343;
  margin-right: 30px;
}

.tab-item.active {
  color: #175dc2;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #434343;
}

.tab-underline {
  position: absolute;
  bottom: -1px;
  left: 50%; /* 从中间开始定位 */
  transform: translateX(-50%);
  width: 15px;
  height: 3px;
  background-color: #175dc2;
  border-radius: 99px;
}

.tab-content {
  margin-top: 20px;
}
</style>
